"use strict";

import {onFind} from "@elements/init-modules-in-scope";
import * as googleMap from "@elements/google-map";
import {initAjaxFormMap as initAjaxFormMapGoogle} from "./ajax-form-google";
import {findAll, findIn, on, findAllIn, find} from '@elements/dom-utils';
import {onEnterViewPort, isElementInViewport, isElementVisible} from "@elements/viewport-utils";

import {
    createPoiStyles,
    getMapStyling,
    onActivateMarker,
    onDeactivateMarker,
    getGoogleInfoBoxOptions,
    createClusterStyles
} from "./google-map";
import {scrollTop} from "./ajax-form-extend";


export function init () {

    findAll('.js-ajax-form-map').map(googleMapElement => {
            let lat = +googleMapElement.getAttribute('data-google-map-initial-lat') || 47.076668;
            let lng = +googleMapElement.getAttribute('data-google-map-initial-lng') || 15.421371;
            let selectors = {
                result: '.js-ajax-form-map__result',
                loading: '.js-ajax-form-map__loading',
                notifications: '.js-ajax-form-map__notifications',
                form: '.js-ajax-form-map__form',
                additionalForm: '.js-ajax-form-map__additional-form',
                errorArea: '.js-ajax-form-map__error-area',
                retry: '.js-ajax-form-map__retry',
                link: '.js-ajax-form-map__link',
                reset: '.js-ajax-form-map__reset',
            };

        onFind('.js-ajax-form-map__map__canvas', function(canvas) {

            let tabs = findAllIn('[data-bs-toggle="tab"]', googleMapElement);
            tabs.map(function(tab) {
                on('shown.bs.tab', function(evt) {
                    let map = findIn('.js-ajax-form-map__map__canvas', googleMapElement);
                    if(map) {
                        onEnterViewPort(map, function (element) {
                            googleMap.getApi(map).then((api) => {
                                api.centerMap();
                            });
                        })
                    }
                }, tab);
            })

            let map = initAjaxFormMapGoogle(googleMapElement, {
                element: canvas,
                poiStyles: () => createPoiStyles(),
                infoBoxOptions: () => getGoogleInfoBoxOptions(),
                clustering: true,
                clusteringOptions: createClusterStyles(),
                onActivateMarker: (marker, api) => onActivateMarker(marker, api),
                onDeactivateMarker: (marker, api) => onDeactivateMarker( marker, api),
                mapOptions: {
                    center: {lat: lat, lng: lng},
                    zoom: 10,
                    scrollwheel: true,
                    mapTypeControl: false,
                    streetViewControl: false,
                    style: getMapStyling()
                },
                consentRenderFunction: () => {
                    const consentOverlay = findIn('.js-consent', googleMapElement);
                    return new Promise((resolve, reject) => {
                        window.addEventListener('CookiebotOnAccept', function (e) {
                            if (Cookiebot.consent.marketing) {
                                resolve();
                                if (consentOverlay) {
                                    consentOverlay.remove();
                                }
                            }
                        });
                    });
                }
            }, selectors);


            onEnterViewPort(find('.js-ajax-form-map__map__canvas'), function (element) {
                googleMap.getApi(element).then((api) => {
                    api.centerMap();
                });
            }, {
                offset: 0
            });
        });

        onFind('.js-ajax-form-map', function ($element) {
            on('fetch.ajax-form', function () {
                scrollTop($element);

                let $filterOverlay = findIn('.js-overlay', $element);
                if ($filterOverlay && hasClass('is-open', $filterOverlay)) {
                    removeClass('is-open', $filterOverlay);
                }

            }, $element);

            let ajaxScrollTopButtons = findAllIn('.js-ajax-scroll-top', googleMapElement)
            if (ajaxScrollTopButtons) {
                ajaxScrollTopButtons.map(function (ajaxScrollTopBtn) {
                    on('click', function () {
                        scrollTop($element);
                    }, ajaxScrollTopBtn);
                });
            }
        });
    })
}